import { render, staticRenderFns } from "./internet-connection-alert.vue?vue&type=template&id=9525e70e&scoped=true&"
import script from "./internet-connection-alert.vue?vue&type=script&lang=js&"
export * from "./internet-connection-alert.vue?vue&type=script&lang=js&"
import style0 from "./internet-connection-alert.vue?vue&type=style&index=0&id=9525e70e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9525e70e",
  null
  
)

export default component.exports